import xdk from '@accedo/xdk-core';

export const isWorkstation = () => {
  return xdk.platform === 'workstation';
};

export const isVIZIO = () => {
  return (
    typeof window !== 'undefined' &&
    /VIZIO|SmartCast|Conjure/i.test(navigator.userAgent)
  );
};

// Vizio UA example
// Mozilla/5.0 (X11; Linux armv7l) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/72.0.3626.121 Safari/537.36 CrKey/1.0.999999 VIZIO SmartCast(Conjure/MTKA-3.1.394.1 FW/4.61.35-1 Model/D24f-F1)
// List of Devices codes
// MTKA = 5581  ** Low End **
// MTKB = 5597
// MTKC = 5691
// MTKD = 5695
// MTKE = 5583  ** Low End **
export const isLowEndDevice = () =>
  navigator.userAgent.toLowerCase().includes('VIZIO') ||
  navigator.userAgent.toLowerCase().includes('SmartCast');

export const isTizen = () => {
  return (
    typeof window !== 'undefined' &&
    /Tizen/i.test(navigator.userAgent) &&
    (/SAMSUNG/i.test(navigator.userAgent) ||
      /SMART-TV/i.test(navigator.userAgent))
  );
};

const mobileRegex = /iPhone|iPad|iPod|Android/i;

// without the check for window it may crash at compiling
// if used outside a component -.-
export const isMobile = () =>
  typeof window !== 'undefined' && mobileRegex.test(navigator.userAgent);
